import { render, staticRenderFns } from "./index.vue?vue&type=template&id=323d1f60&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=323d1f60&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323d1f60",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Autocounter: require('/opt/atlassian/pipelines/agent/build/components/Autocounter.vue').default})
